import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { MainNavigationItemComponent } from '@core/navigation-legacy';
import {
  ConnectedOverlayDirective,
  DotComponent,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-help-dropdown',
  templateUrl: './help-dropdown.component.html',
  styleUrl: './help-dropdown.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DotComponent,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    MainNavigationItemComponent,
    TranslatePipe,
  ],
})
export class HelpDropdownComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public helpCenterUrlKey = input('app.support_fab.help_center_recruitee_url');
  public productUpdatesUrl = input('https://updates.tellent.com');
  public shareFeedbackUrl = input('https://feedback.tellent.com');
  public showGetStarted = input(true);
  public isActive = input(false);
  public isUnread = input(false);

  public chatWithUs = output<void>();
  public getStarted = output<void>();
  public productUpdatesClick = output<void>();

  protected onProductUpdatesClick(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.productUpdatesClick.emit();
  }

  protected onGetStarted(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.getStarted.emit();
  }

  protected onChatWithUs(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = false;
    this.chatWithUs.emit();
  }
}
